<template>
  <div>
    <Modal title="角色人员" :value="value" @on-visible-change="change">
      <CheckboxGroup v-model="selection">
        <span v-for="item in roleList" :key="item.id">
          <Checkbox :label="item.id" class="checkbox-item" :class="{'checked-item': selection.indexOf(item.name) !== -1}">
            <span>{{item.name}}</span>
          </Checkbox>
        </span>
      </CheckboxGroup>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="confirm" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    roleList: {
      type: Array
    },
    reportId: Number
  },
  data(){
    return {
      selection: []
    }
  },
  methods: {
    selected() {
      this.selection = []
      ajax.get(`${requestUrls.AbpReportSysSetting.GetRoleListByReprotSysId}?setting_id=${this.reportId}`).then(res => {
        res.data.result.items.forEach(item => {
          this.selection.push(item.id)
        })
      })
    },
    confirm(){
      ajax.put(`${requestUrls.AbpReportSysSetting.UpdateReportSysByRoles}?report_sys_id=${this.reportId}`,this.selection).then(res => {
        this.$Message.success('绑定成功')
      })
      this.$emit('save-success')
    },
    cancel(){
      this.$emit('save-success')
    },
    change(val){
      if(!val){
        this.$emit('save-success')
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 修改checkbox样式
.checkbox-item {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  &:hover {
    border-color: #2d8cf0;
  }
}
.checked-item {
  border-color: #2d8cf0;
}
/deep/ .ivu-modal-body {
  height: 300px;
  overflow-y: auto;
}
</style>
